export default {
  PERMISSIONS_SET_OPERATOR: 'PERMISSIONS_SET_OPERATOR'
}